import React from 'react'
import '../styles/style.css'
import no from '../images/no.svg'

class Empty extends React.Component {
    render() {

        return (
            <div className="container-ex">
                <div className="content-empty">
                    <img src={no}></img>
                    <p className="no-text">No videos for {this.props.categoryName} yet</p>
                </div>
            </div>
        );
    }
}

export default Empty;